/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Insights_Organisationstotal2Inputs */

const en_coinvestments_insights_organisationstotal2 = /** @type {(inputs: Coinvestments_Insights_Organisationstotal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisations`)
};

/**
* | output |
* | --- |
* | "Organisations" |
*
* @param {Coinvestments_Insights_Organisationstotal2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_organisationstotal2 = /** @type {((inputs?: Coinvestments_Insights_Organisationstotal2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Organisationstotal2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_organisationstotal2(inputs)
});
export { coinvestments_insights_organisationstotal2 as "coInvestments_insights_organisationsTotal" }